webpackJsonp([213534597649335],{

/***/ 237:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  border: 1px solid ', ';\n  border-radius: 3px;\n  padding: 25px;\n  font-size: 2rem;\n  color: ', ';\n  display: inline-block;\n  transition: all 0.3s ease;\n\n  &:hover {\n    color: white;\n    background: ', ';\n  }\n'], ['\n  border: 1px solid ', ';\n  border-radius: 3px;\n  padding: 25px;\n  font-size: 2rem;\n  color: ', ';\n  display: inline-block;\n  transition: all 0.3s ease;\n\n  &:hover {\n    color: white;\n    background: ', ';\n  }\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(58);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _styledComponents = __webpack_require__(15);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ctaButton = function (_Component) {
	  _inherits(ctaButton, _Component);
	
	  function ctaButton() {
	    _classCallCheck(this, ctaButton);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  ctaButton.prototype.render = function render() {
	    var children = this.props.children;
	
	    return _react2.default.createElement(
	      _gatsbyLink2.default,
	      { style: { border: 'none' }, to: this.props.to },
	      _react2.default.createElement(
	        ButtonContainer,
	        null,
	        children
	      )
	    );
	  };
	
	  return ctaButton;
	}(_react.Component);
	
	exports.default = ctaButton;
	
	
	var ButtonContainer = _styledComponents2.default.div(_templateObject, function (props) {
	  return props.theme.brand;
	}, function (props) {
	  return props.theme.brand;
	}, function (props) {
	  return props.theme.brand;
	});
	module.exports = exports['default'];

/***/ }),

/***/ 50:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(22);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _SiteConfig = __webpack_require__(16);
	
	var _SiteConfig2 = _interopRequireDefault(_SiteConfig);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SEO = function (_Component) {
	  _inherits(SEO, _Component);
	
	  function SEO() {
	    _classCallCheck(this, SEO);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  SEO.prototype.render = function render() {
	    var _props = this.props,
	        postNode = _props.postNode,
	        postPath = _props.postPath,
	        postSEO = _props.postSEO;
	
	    var title = void 0;
	    var description = void 0;
	    var image = void 0;
	    var postURL = void 0;
	    if (postSEO) {
	      var postMeta = postNode.frontmatter;
	      title = postMeta.title;
	      description = postMeta.description ? postMeta.description : postNode.excerpt;
	      image = postMeta.cover;
	      postURL = _SiteConfig2.default.siteUrl + _SiteConfig2.default.pathPrefix + postPath;
	    } else {
	      title = _SiteConfig2.default.siteTitle;
	      description = _SiteConfig2.default.siteDescription;
	      image = _SiteConfig2.default.siteLogo;
	    }
	    var realPrefix = _SiteConfig2.default.pathPrefix === '/' ? '' : _SiteConfig2.default.pathPrefix;
	    image = _SiteConfig2.default.siteUrl + realPrefix + image;
	    var blogURL = _SiteConfig2.default.siteUrl + _SiteConfig2.default.pathPrefix;
	    var schemaOrgJSONLD = [{
	      '@context': 'http://schema.org',
	      '@type': 'WebSite',
	      url: blogURL,
	      name: title,
	      alternateName: _SiteConfig2.default.siteTitleAlt ? _SiteConfig2.default.siteTitleAlt : ''
	    }];
	    if (postSEO) {
	      schemaOrgJSONLD.push([{
	        '@context': 'http://schema.org',
	        '@type': 'BreadcrumbList',
	        itemListElement: [{
	          '@type': 'ListItem',
	          position: 1,
	          item: {
	            '@id': postURL,
	            name: title,
	            image: image
	          }
	        }]
	      }, {
	        '@context': 'http://schema.org',
	        '@type': 'BlogPosting',
	        url: blogURL,
	        name: title,
	        alternateName: _SiteConfig2.default.siteTitleAlt ? _SiteConfig2.default.siteTitleAlt : '',
	        headline: title,
	        image: {
	          '@type': 'ImageObject',
	          url: image
	        },
	        description: description
	      }]);
	    }
	    return _react2.default.createElement(
	      _reactHelmet2.default,
	      null,
	      _react2.default.createElement('meta', { name: 'description', content: description }),
	      _react2.default.createElement('meta', { name: 'image', content: image }),
	      _react2.default.createElement(
	        'script',
	        { type: 'application/ld+json' },
	        JSON.stringify(schemaOrgJSONLD)
	      ),
	      _react2.default.createElement('meta', { property: 'og:url', content: postSEO ? postURL : blogURL }),
	      postSEO ? _react2.default.createElement('meta', { property: 'og:type', content: 'article' }) : null,
	      _react2.default.createElement('meta', { property: 'og:title', content: title }),
	      _react2.default.createElement('meta', { property: 'og:description', content: description }),
	      _react2.default.createElement('meta', { property: 'og:image', content: image }),
	      _react2.default.createElement('meta', {
	        property: 'fb:app_id',
	        content: _SiteConfig2.default.siteFBAppID ? _SiteConfig2.default.siteFBAppID : ''
	      }),
	      _react2.default.createElement('meta', { name: 'twitter:card', content: 'summary_large_image' }),
	      _react2.default.createElement('meta', {
	        name: 'twitter:creator',
	        content: _SiteConfig2.default.userTwitter ? _SiteConfig2.default.userTwitter : ''
	      }),
	      _react2.default.createElement('meta', { name: 'twitter:title', content: title }),
	      _react2.default.createElement('meta', { name: 'twitter:description', content: description }),
	      _react2.default.createElement('meta', { name: 'twitter:image', content: image })
	    );
	  };
	
	  return SEO;
	}(_react.Component);
	
	exports.default = SEO;
	module.exports = exports['default'];

/***/ }),

/***/ 248:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  background: ', ';\n  padding: ', ';\n  text-align: center;\n'], ['\n  background: ', ';\n  padding: ', ';\n  text-align: center;\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n  padding: 50px 0;\n  & > h1 {\n    font-weight: 600;\n  }\n'], ['\n  padding: 50px 0;\n  & > h1 {\n    font-weight: 600;\n  }\n']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['\n  padding: ', ';\n  max-width: ', ';\n  margin: 0 auto;\n\n  .contributors {\n    max-width: 400px;\n    margin: 100px auto 0;\n  }\n'], ['\n  padding: ', ';\n  max-width: ', ';\n  margin: 0 auto;\n\n  .contributors {\n    max-width: 400px;\n    margin: 100px auto 0;\n  }\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(22);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _styledComponents = __webpack_require__(15);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _SEO = __webpack_require__(50);
	
	var _SEO2 = _interopRequireDefault(_SEO);
	
	var _SiteConfig = __webpack_require__(16);
	
	var _SiteConfig2 = _interopRequireDefault(_SiteConfig);
	
	var _CtaButton = __webpack_require__(237);
	
	var _CtaButton2 = _interopRequireDefault(_CtaButton);
	
	var _Navigation = __webpack_require__(67);
	
	var _Navigation2 = _interopRequireDefault(_Navigation);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Index = function (_React$Component) {
	  _inherits(Index, _React$Component);
	
	  function Index() {
	    _classCallCheck(this, Index);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Index.prototype.render = function render() {
	    var allSEOMarkdown = this.props.data.allMarkdown.edges;
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'index-container' },
	      _react2.default.createElement(_reactHelmet2.default, { title: _SiteConfig2.default.siteTitle }),
	      _react2.default.createElement(_SEO2.default, { postEdges: allSEOMarkdown }),
	      _react2.default.createElement(
	        'main',
	        null,
	        _react2.default.createElement(
	          IndexHeadContainer,
	          null,
	          _react2.default.createElement(_Navigation2.default, null),
	          _react2.default.createElement(
	            Hero,
	            null,
	            _react2.default.createElement('img', { src: _SiteConfig2.default.siteLogo, width: '150px', alt: '' }),
	            _react2.default.createElement(
	              'h1',
	              null,
	              _SiteConfig2.default.siteTitle
	            ),
	            _react2.default.createElement(
	              'h4',
	              null,
	              _SiteConfig2.default.siteDescription
	            )
	          )
	        ),
	        _react2.default.createElement(
	          BodyContainer,
	          null,
	          _react2.default.createElement(
	            'font',
	            { color: 'green' },
	            _react2.default.createElement(
	              'h1',
	              null,
	              'Welcome to the Green Book,a comprehensive guide to key processes and principles for our Operating Companies.'
	            )
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'This site is designed to empower you by clearly laying out the principles, practices and expectations that underpin our ways of working. You, our Operating Company leaders, need clarity, so you can go faster and make big decisions with absolute certainty about when DMGT\u2019s involvement is needed, and when it is not.',
	            _react2.default.createElement('br', null),
	            'The working relationship between DMGT and its Operating Companies is, more than ever, critical to our success.',
	            _react2.default.createElement('br', null),
	            'That relationship has evolved to meet the growing demands of the markets we operate in, and now is the right time to strengthen that relationship by setting out clear, mutual expectations of how we will work together.',
	            _react2.default.createElement('br', null),
	            'By developing this understanding, we can progress more quickly, confidently and effectively towards our shared goals, deliver our Group-wide Performance Improvement Programme and position our businesses for sustainable, profitable growth.',
	            _react2.default.createElement('br', null),
	            'Each business within our portfolio of number one brands has tremendous potential and opportunity ahead. DMGT is here to empower you, to support and encourage our shared values of entrepreneurialism, purpose and excellence, and to enable your success.'
	          )
	        )
	      )
	    );
	  };
	
	  return Index;
	}(_react2.default.Component);
	
	exports.default = Index;
	
	
	var IndexHeadContainer = _styledComponents2.default.div(_templateObject, function (props) {
	  return props.theme.brand;
	}, function (props) {
	  return props.theme.sitePadding;
	});
	
	var Hero = _styledComponents2.default.div(_templateObject2);
	
	var BodyContainer = _styledComponents2.default.div(_templateObject3, function (props) {
	  return props.theme.sitePadding;
	}, function (props) {
	  return props.theme.contentWidthLaptop;
	});
	
	/* eslint no-undef: "off" */
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-jsx-ecf93782d61e4f333b1b.js